<template>
    <div class="select-user-content">
        <csc-base-user-card
            class="select-user"
            :userCardInfo="selectedUser"
            :isSelected="false"
        ></csc-base-user-card>
        <csc-list
            :list="userWorkList"
            :showLoading="showLoading"
            :emptyText="selectedConfig.emptyText"
            :emptyIcon="selectedConfig.emptyIcon"
            class="select-user-list"
        >
            <div class="live-item" v-for="(item, index) in userWorkList" :key="index">
                <csc-base-live-card
                    :liveCardInfo="item"
                    showTitleCaption
                    @chooseClick="workItemClick"
                ></csc-base-live-card>
            </div>
            <div
                v-if="hasMore"
                v-io
                class="list-loading"
                @exposed="getMoreData"
            ></div>
        </csc-list>
        <no-result-btn @on-no-result-click="onNoResult"></no-result-btn>
    </div>
</template>
<script>
import CscDesign from '@ks-csc/mobile-design';
import NoResultBtn from '../component-base/common/no-result-btn';
import IntersectionObserve from '../../utils/directives/intersection-observe';
const { CscList, CscBaseLiveCard, CscBaseUserCard } = CscDesign;
export default {
    name: 'selected-user',
    directives: {
        io: IntersectionObserve,
    },
    components: {
        CscList,
        CscBaseLiveCard,
        CscBaseUserCard,
        NoResultBtn,
    },
    props: {
        showSelf: {
            type: Boolean,
            default: false,
        },
        showAll: {
            type: Boolean,
            default: true,
        },
        selectedUser: {
            type: Object,
            default: () => {},
        },
        selectedConfig: {
            type: Object,
            default: () => {},
        },
    },
    watch: {
        selectedUser: {
            immediate: true,
            deep: true,
            async handler(val) {
                if (!val) {return;}
                this.userWorkList = [];
                this.page = 0;
                this.showLoading = true;
                await this.fetchUserWorks();
                this.showLoading = false;
            },
        },
    },
    data() {
        return {
            showLoading: false,
            hasMore: false,
            userWorkList: [],
            page: 0,
            cursor: 0,
        };
    },
    methods: {
        onNoResult() {
            this.$emit('on-no-result-click');
        },
        async fetchUserWorks() {
            if (this.showSelf) {
                const { hasMore, list, nextCursor } = await this.selectedConfig.getListV2({
                    targetUserId: this.selectedUser.userId,
                    cursor: this.cursor,
                    queryAll: this.showAll,
                });
                this.userWorkList = [...this.userWorkList, ...list];
                this.hasMore = hasMore;
                this.cursor = nextCursor;
            } else {
                const { hasMore, list } = await this.selectedConfig.getList({
                    targetUserId: this.selectedUser.userId,
                    offset: this.page * 10,
                });
                this.userWorkList = [...this.userWorkList, ...list];
                this.hasMore = hasMore;
                this.page += 1;
            }
        },
        getMoreData() {
            this.fetchUserWorks();
        },
        workItemClick(item) {
            this.$emit('work-item-click', item);
        },
    },
};
</script>

<style lang="less" scoped>
@import '../../style.less';
.select-user-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
}
.select-user {
  width: 3.76rem;
  margin: 0 19px;
  /deep/ .csc-image img {
        object-fit: cover;
        position: static;
        transform: none;
        border-radius: 50%;
        &::after {
            display: none;
        }
    }
}
.list-loading {
    width: 0.3rem;
    height: 0.3rem;
    margin: 0 auto;
    background: var(--csc-collect-list-loading) no-repeat;
    background-size: contain;
}
.select-user-list {
    margin: 0.18rem 0.15rem 0 0.15rem;
    flex: 1;
    overflow: auto;
  /deep/ .no-data {
    margin-top: 172px;
  }
  /deep/ .k-loading {
    margin-top: 172px;
  }
  /deep/ .list {
        display: flex;
        flex-wrap: wrap;
        .live-card {
            background-color: var(--button-bg, #fff) !important;
            /deep/ .csc-image img {
                object-fit: cover;
                position: static;
                transform: none;
                border-radius: 50%;
                &::after {
                    display: none;
                }
            }
        }
    }
    .live-item {
    margin: 0 0.04rem 0.08rem;
    width: 1.84rem;
}
}
</style>
